import { LoadingArea } from '@consigli/facade';
import { useProjectId, useBuildingPackageId, useBuildingPackageResults } from '@consigli/hooks';
import { convertFileToDocumentWithFileType } from '@consigli/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CardBasedFileDisplay, RESULT_SECTIONS } from '@/components/card-based-file-display';
import { DismissibleDisclaimer } from '@/components/dismissible-disclaimer';
import { WaitingForAnalysis } from '@/components/waiting-for-analysis';
import { Breadcrumb } from '@/features/breadcrumb/breadcrumb';
import { WorkspaceProvider } from '@/layouts/workspace-layout/use-workspace-context';
import { WorkspaceLayout } from '@/layouts/workspace-layout/workspace-layout';

export const BuildingPackageResultPage: FC = () => {
  const projectId = useProjectId();
  const buildingPackageId = useBuildingPackageId();
  const { t } = useTranslation();

  const { results, isLoading, isFetching } = useBuildingPackageResults({
    projectId,
    buildingPackageId,
    page: 'all',
  });

  return (
    <>
      <Breadcrumb label={t('optimization-tabs.results')} />
      <WorkspaceProvider>
        <WorkspaceLayout>
          {isLoading ? (
            <LoadingArea title={t('document-list.loading')} />
          ) : results.length === 0 ? (
            <WaitingForAnalysis />
          ) : (
            <>
              <DismissibleDisclaimer>{t('optimization-tabs.ai-disclaimer')}</DismissibleDisclaimer>
              <div className="flex">
                <CardBasedFileDisplay
                  files={results.map((result) =>
                    convertFileToDocumentWithFileType(result.file, result.type),
                  )}
                  isFetching={isFetching}
                  isPublished={true}
                  sections={RESULT_SECTIONS}
                />
              </div>
            </>
          )}
        </WorkspaceLayout>
      </WorkspaceProvider>
    </>
  );
};
